import React from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ViewDocs from "../ViewDocs";
import DocVideos from "../DocVideos";
import { formatDateTime, isMoreThan7DaysOld } from "../../common-data/Converts";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { delete_docs } from "../../../data/ApiEndpoints";
import { dashURL } from "../../common-data/Commons";

const DocList = ({
  tbData,
  userInfoData,
  setModValues,
  callFunction,
  isCRUDAllow,
}) => {
  const dispatch = useDispatch();
  const isAdmin = userInfoData?.account_type === "admin";

  const isEnabled = tbData?.date_added
    ? isMoreThan7DaysOld(tbData.date_added)
    : true;

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_docs,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Feature is deleted successfully!"
            );
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete Feature!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Feature");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this Feature!`
      );
    } else {
      toast.error("UID required!");
    }
  };

  return (
    <div className="docs-list">
      <div className="flexCol mt30">
        <h3 className="docs-heading">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-book-half"
            viewBox="0 0 16 16"
            style={{ color: "#1abc9c" }}>
            <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
          </svg>{" "}
          {tbData?.feature_doc_name || ""} |{" "}
          {isCRUDAllow && (
            <>
              <button
                className="doc-action-btn"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "edit",
                    rowData: tbData,
                  }))
                }>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-fill"
                  viewBox="0 0 16 16"
                  style={{ color: "#bc0909" }}>
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </button>
              <button
                className="doc-action-btn"
                style={{ marginLeft: "15px" }}
                onClick={() => {
                  const filters = {
                    uid: tbData?.uid || "",
                  };
                  handleDelete(filters);
                }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash-fill"
                  viewBox="0 0 16 16"
                  style={{ color: "#bc0909" }}>
                  <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                </svg>
              </button>
            </>
          )}
          <button
            className="doc-action-btn"
            style={{
              cursor: isEnabled ? "pointer" : "not-allowed",
              opacity: isEnabled ? "1" : "0.5",
              marginLeft: "15px",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "feedback",
                rowData: tbData,
              }))
            }
            disabled={!isEnabled}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-list-stars"
              viewBox="0 0 16 16"
              style={{ color: "#bc0909" }}>
              <path
                fillRule="evenodd"
                d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5"
              />
              <path d="M2.242 2.194a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.28.28 0 0 0-.094.3l.173.569c.078.256-.213.462-.423.3l-.417-.324a.27.27 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.28.28 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.27.27 0 0 0 .259-.194zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.28.28 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.27.27 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.28.28 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.27.27 0 0 0 .259-.194zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.28.28 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.27.27 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.28.28 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.27.27 0 0 0 .259-.194z" />
            </svg>
          </button>
        </h3>

        <div className="documentation-log">
          <ViewDocs content={tbData?.feature_documentation || ""} />
        </div>
      </div>

      {tbData?.feature_external_links?.length > 0 ? (
        <div className="flexCol mt30">
          <h3 className="docs-heading">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-share-fill"
              viewBox="0 0 16 16"
              style={{ color: "#1abc9c" }}>
              <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5" />
            </svg>{" "}
            External Links
          </h3>

          <div className="documentation-links">
            {tbData.feature_external_links?.map((link, index) => (
              <div className="external-document" key={index}>
                <p className="doc-title">{link?.link_title || ""}</p>
                <a
                  href={link?.link_path}
                  rel="noreferrer"
                  target="_blank"
                  className="doc-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-box-arrow-up-right"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#1B56FD",
                      width: "30px",
                      height: "30px",
                    }}>
                    <path
                      fillRule="evenodd"
                      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                    />
                    <path
                      fillRule="evenodd"
                      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                    />
                  </svg>
                </a>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {tbData?.feature_videos?.length > 0 ? (
        <div className="flexCol documentation-videos mt30">
          <h3 className="docs-heading">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-play-circle-fill"
              viewBox="0 0 16 16"
              style={{ color: "#1abc9c" }}>
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z" />
            </svg>{" "}
            Videos
          </h3>

          <div className="documentation-links">
            <DocVideos feature_videos={tbData.feature_videos || []} />
          </div>
        </div>
      ) : null}

      {tbData?.feature_relevant_for?.length > 0 ? (
        <div className="flexCol documentation-stakeholders mt30">
          <h3 className="docs-heading">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-person-lines-fill"
              viewBox="0 0 16 16"
              style={{ color: "#1abc9c" }}>
              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
            </svg>{" "}
            Document Relevant For
          </h3>

          <div className="documentation-links">
            {tbData.feature_relevant_for?.map((stakeholder, index) => (
              <p className="doc-stakeholder" key={index}>
                {stakeholder?.replace(/_/g, " ") || ""}
              </p>
            ))}
          </div>
        </div>
      ) : null}

      {isAdmin && (
        <div className="flexCol mt30">
          <h3 className="docs-heading">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-bell-fill"
              viewBox="0 0 16 16"
              style={{ color: "#1abc9c" }}>
              <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-1.203-2.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
            </svg>{" "}
            Notification Status
          </h3>

          <div className="documentation-log">
            <p
              className={`doc-notification-status ${
                tbData?.is_notified === 1
                  ? "doc-notification-status--notified"
                  : "doc-notification-status--not-notified"
              }`}>
              {tbData?.is_notified === 1
                ? "✓ User has been notified"
                : "✗ User has not been notified"}
            </p>
          </div>
        </div>
      )}

      <div className="flexCol mt30">
        <h3 className="docs-heading">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-link-45deg"
            viewBox="0 0 16 16"
            style={{ color: "#1abc9c" }}>
            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
            <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
          </svg>{" "}
          Feature Link
        </h3>

        <div className="documentation-log">
          <a
            href={`${dashURL}${tbData?.feature_access_link}`}
            rel="noreferrer"
            target="_blank"
            className="doc-link">
            {tbData?.feature_name || ""}
          </a>
        </div>
      </div>

      <div className="flexCol mt30">
        <h3 className="docs-heading">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-info-circle-fill"
            viewBox="0 0 16 16"
            style={{ color: "#1abc9c" }}>
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM8 4a.905.905 0 0 1 .9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6.002a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>{" "}
          Additional Details
        </h3>
        <div className="documentation-log">
          <p className="doc-details">
            <strong>Date Added:</strong>{" "}
            {tbData?.date_added ? formatDateTime(tbData?.date_added) : ""}
          </p>
          <p className="doc-details">
            <strong>Last Updated:</strong>{" "}
            {tbData?.last_updated ? formatDateTime(tbData?.last_updated) : ""}
          </p>
          {isAdmin && (
            <p className="doc-details">
              <strong>Status:</strong>
              <span
                className={`doc-status ${
                  tbData?.status === "active"
                    ? "doc-status--active"
                    : "doc-status--inactive"
                }`}>
                {tbData?.status}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocList;
